import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  '@global': {
    '#indemn-webchat .rw-conversation-container .rw-message .rw-response .rw-markdown a[href]': {
      // Staff's global display: contents removes the box needed for link decoration and focus.
      display: 'inline',
      textDecoration: 'underline solid !important',
      textUnderlineOffset: '0.15em',
      cursor: 'pointer',
      '&:focus-visible': {
        outline: '2px solid currentColor',
        outlineOffset: 2
      }
    }
  },
  // Touch panning or text selection would otherwise cancel or muddy a drag of the launcher.
  anchor: {
    '& .rw-launcher': { touchAction: 'none', userSelect: 'none' }
  },
  // Indemn.chat.hide() closes the conversation window but leaves its launcher in this anchor.
  hidden: { display: 'none !important' },
  // The SDK positions both boxes with inline styles, hence !important. Values come from
  // getLauncherPlacement; the mobile drawer keeps its own full-width layout.
  moved: ({ placement }) => ({
    ...placement,
    '& .rw-launcher-container': {
      left: 'var(--launcher-left) !important',
      right: 'var(--launcher-right) !important',
      bottom: 'var(--launcher-bottom) !important',
      alignItems: 'var(--launcher-align) !important'
    },
    '& .rw-widget-container:not(.rw-mobile-shell)': {
      top: 'var(--window-top) !important',
      right: 'var(--window-right) !important',
      bottom: 'var(--window-bottom) !important',
      left: 'var(--window-left) !important',
      maxHeight: 'var(--window-max-height) !important',
      minHeight: 'unset !important'
    },
    '& .rw-widget-container:not(.rw-mobile-shell) .rw-powered-by-box': {
      left: 'var(--powered-by-left) !important',
      right: 'var(--powered-by-right) !important'
    }
  })
}));
